import * as React from 'react';

import {api} from 'nutshell-core/api';

import type {Lead as LeadFragment} from 'nutshell-graphql-types';

import {LeadStageChevron} from './lead-stage-chevron';

import styles from './stages-carousel-stages.module.css';

type Props = {
    lead: LeadFragment;
    temporarilySelectedStageId: string | null | undefined;
    onTemporarilySelectStage: (id: string) => any;
    onClearTemporaryStageSelection: () => any;
    onRefetchLead: () => any;
    getStagesRef: (arg1?: HTMLElement | null | undefined) => void;
};

type State = {
    isLoading: boolean;
};

export class StagesCarouselStages extends React.PureComponent<Props, State> {
    constructor() {
        // @ts-expect-error
        super();
        this.state = {
            isLoading: false,
        };
    }

    render() {
        const stages = this.props.lead.stages.edges;
        const isHot = this.props.lead.isHot;
        const activeStageEdge = this.activeStageEdge();
        // @ts-expect-error
        const activeStageIndex = stages.indexOf(activeStageEdge);

        const items = stages.map((stageEdge, index) => {
            const stage = stageEdge.node;
            const isActive = stageEdge.isActive;

            const isSelected = this.props.temporarilySelectedStageId
                ? this.props.temporarilySelectedStageId === stage.id
                : isActive;
            const isOtherSelected = this.props.temporarilySelectedStageId
                ? this.props.temporarilySelectedStageId !== stage.id
                : false;

            return (
                <LeadStageChevron
                    stageId={stage.id}
                    stageName={stage.name}
                    timeInStage={
                        stageEdge.timeInStage ? stageEdge.timeInStage.formattedString : undefined
                    }
                    stageOverdueTime={isActive ? this.props.lead.stageOverdueTime : undefined}
                    isLoading={this.state.isLoading && isSelected}
                    isFirstChild={index === 0}
                    isLastChild={index + 1 === stages.length}
                    isActive={isActive}
                    isPast={index < activeStageIndex}
                    isHot={isHot}
                    isSelected={isSelected || (isActive && !isOtherSelected)}
                    onActivateStage={this.handleActivateStage}
                    onSelectStage={this.handleSelectStage}
                    status={this.props.lead.status}
                    key={stage.id}
                />
            );
        });

        return (
            <div ref={this.props.getStagesRef} className={styles['stages-container']}>
                {items}
            </div>
        );
    }

    // Called when a user clicks on the stage for the first time.
    // A confirmation is required to actually change the stage.
    handleSelectStage = (stage: {id: string}) => {
        const activeStageEdge = this.activeStageEdge();

        if (activeStageEdge && stage.id === activeStageEdge.node.id) {
            this.props.onClearTemporaryStageSelection();
        } else {
            this.props.onTemporarilySelectStage(stage.id);
        }
    };

    handleActivateStage = (stageId: string) => {
        const data = [
            {
                op: 'replace',
                path: '/leads/0/links/stage',
                value: stageId,
            },
        ];

        this.setState({isLoading: true});

        api.patch(`leads/${this.props.lead.id}`, data)
            .then(() => {
                // Refetch old sales process steps to show any that were updated
                // @ts-expect-error
                if (window.Nut && window.Nut.modules && window.Nut.modules.Process) {
                    // @ts-expect-error
                    window.Nut.modules.Process.reloadProcesses();
                }

                // Refetch our backbone portion of the lead
                // @ts-expect-error
                window.currentLead.fetch();

                // Refetch on GraphQL portion of the lead
                this.props.onRefetchLead();

                // Refresh timeline to show stage change
                Timeline.refreshTimeline();

                // Adding a slight delay here, to better align loading
                // and active states
                setTimeout(this.finishLoading, 600);
            })
            .catch(() => {
                this.finishLoading();
            });
    };

    activeStageEdge() {
        const stages = this.props.lead.stages.edges;

        return stages.find((stageEdge) => stageEdge.isActive);
    }

    finishLoading = () => {
        this.setState({isLoading: false});
    };
}
